import React from 'react';
import { DNABox, Icon, DNAButton, luxColors, DNAText } from '@alucio/lux-ui';
import { StyleSheet } from 'react-native';
const styles = StyleSheet.create({
    container: {
        backgroundColor: luxColors.contentPanelBackground.primary,
        borderRadius: 8,
        width: 400,
        height: 288,
    },
    shareContainer: {
        marginTop: 64,
        marginBottom: 64,
    },
    monitorIcon: {
        color: luxColors.info.primary,
        height: 32,
        width: 32,
    },
    text: {
        color: luxColors.info.primary,
    },
});
export default function ScreenPlaceHolder(props) {
    return (React.createElement(DNABox, { alignX: "center", style: styles.container },
        React.createElement(DNABox, { alignX: "center", appearance: "col", spacing: "large", style: styles.shareContainer },
            React.createElement(Icon, { name: "monitor-share", style: styles.monitorIcon }),
            React.createElement(DNAText, { h4: true, status: "info", style: styles.text }, "You are currently screen sharing"),
            React.createElement(DNAButton, { style: { paddingHorizontal: 16, borderRadius: 30 }, onPress: props.onStopShare, size: "tiny" }, "Stop share"))));
}
//# sourceMappingURL=PlaceHolder.js.map